module.exports = __webpack_public_path__ + "media/images/pc/shop/step-01-b275e6bef56b06d8258a37e7d536c98c.png";